import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [];

export const DefaultLayoutRoutes = RouterModule.forChild(routes);
